import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'school-homeside-ui',
  templateUrl: './home-side-ui.component.html',
  styleUrls: ['./home-side-ui.component.scss']
})
export class HomesideuiComponent implements OnInit {

  @Input() title: any;
  @Input() shortdesc: any;
  constructor() { }

  ngOnInit(): void {
  }

}
